import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./verifyOtpExchangePage.css";
import Header from "../components/common/header";
import Footer from "../components/common/footer";
import { useExchangeUser } from "../../contexts/userExchangeProgramContext";

const VerifyExchangeOtp = () => {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [error, setError] = useState("");
  const [seconds, setSeconds] = useState(60);
  const [isDisabled, setIsDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [orderNumber, setOrderNumber] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const userId = location.state?.user_id;
  let returnUrl = location.state?.returnUrl;
  const product = location.state?.product;
  const userInfo = location.state?.user;
  const cartId = location.state?.cart_id;
  const session_code = location.state?.session_code;
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const daikin_auth = "UzAwMTY1Mzk2ODE6MElDPDFIJkY=";
  const daikin_user_creation_url = process.env.REACT_APP_DEMO_FRONT_URL;
  const { auth_token, cust_info, order_id, user_id,fetchCsrfToken } = useExchangeUser();

  const nameInputRef = useRef<Array<HTMLInputElement | null>>([]);
  const prog_id = location.state?.prog_id

  const version = process.env.REACT_APP_VERSION;

  useEffect(() => {
    fetchSeoMetaDetails()
  },[]);

const fetchSeoMetaDetails = async () => {
    try {
        const code = 'exchnage_verify_otp'
        const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`,
          {  method: 'GET',
            headers:{
              // Accept:'aplication/json',
              "Content-Type": "application/json",
      
            },
            credentials: "include",
            mode:"cors"   
                                               
          }
        );
        if (!response.ok) throw new Error('Failed to fetch categories');
        const data = await response.json();
        await changeTitleAndMetaTags(data.result.page_title, {description:data.result.meta_description,keywords:data.result.meta_tag});
    } catch (error) {
        //console.error('Error fetching categories:', error);
    }
  };
  
  const changeTitleAndMetaTags = async (
    title: string,
    metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
  ) => {
    try {
        // Update the document title
        if (title) {
            document.title = title;
        } else {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
        }
  
        // Update or create meta tags
        Object.keys(metaTags).forEach((metaName) => {
            const metaTag = document.querySelector(`meta[name="${metaName}"]`);
            if (metaTag) {
                // Update existing meta tag
                metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
            } else {
                // Create new meta tag if it doesn't exist
                const newMetaTag = document.createElement('meta');
                newMetaTag.name = metaName;
                newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                document.head.appendChild(newMetaTag);
            }
        });
  
        // Cleanup function to reset the title and meta tags when unmounting
        return () => {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
            Object.keys(metaTags).forEach((metaName) => {
                const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                if (metaTag) {
                    metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                }
            });
        };
    } catch (error) {
        //console.error("Error updating title and meta tags:", error);
    }
  };

  const saveDaikinInfo = async () => {
    const requestBody = JSON.stringify({
      ...cust_info,
    });
    
    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(
        `${backendUrl}api/v2/daikin-user-create/${order_id}/${user_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
          body: requestBody,
          
        }
      );
      const data = await response.json();

      setLoading(false); // Stop loader
      // navigate('/exchange/programechangesubmit');
    } catch (err) {
      //console.error("Error submitting Daikin info:", err);
      setLoading(false);
      setError("Error submitting Daikin info");
    }
  };

  const saveDaikinOrderInfo = async () => {
    const requestBody = JSON.stringify({
      ...cust_info,
    });

    const savedRequestData = JSON.parse(sessionStorage.getItem("addressInfo") || "{}");
    
    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(
        `${backendUrl}api/v2/daikin-order-save/${order_id}/${user_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
          body:savedRequestData,
          
        }
      );
      const data = await response.json();
      //console.log("saveDaikinOrderInfoyghjkl;kuhgfhjkl;kjhb", data);
      setOrderNumber(data.data);

      setLoading(false); // Stop loader

      return data.data;
    } catch (err) {
      //console.error("Error submitting Daikin info:", err);
      setLoading(false);
      setError("Error submitting Daikin info");
    }
  };

  const handleResendExpireOtp = async () => {
    try {
      // setIsDisabled(true);
    const mobileNum = sessionStorage.getItem('mobile_no');
      // setSeconds(RESEND_OTP_TIMEOUT);
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(`${backendUrl}api/v2/resend-otp-expire-exchange/${user_id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'auth-token': `${auth_token}`,
          'X-CSRF-Token': csrfToken,
        },
        credentials: "include",
        body: JSON.stringify({ userInfo ,mobileNum}),
        
      });

      if (!response.ok) {
        throw new Error('Failed to resend OTP');
      }

      

      //console.log('OTP resent successfully');
      // Reset timer
      // Disable resend button
    } catch (error) {
      //console.error('Error resending OTP:', error);
      setError('Failed to resend OTP');
    }
  };

  // /api/v2/daikin-order-save/:order_id/:user_id

  const handleChange = (element: HTMLInputElement, index: number) => {
    const value = element.value.replace(/\D/g, "");
    //console.log("value=   ", index);
    if (value.length === 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (element.nextSibling) {
        (element.nextSibling as HTMLInputElement).focus();
      }
    }
  };

  useEffect(() => {
    if (otp.join("").length === otp.length) {
      handleOtpSubmit();
    }
  }, [otp]);

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
      //console.log("backspace", index);
      if (index > 0) {
        nameInputRef.current[index - 1]?.focus();
      }
    }
  };

  const handleResendOtp = async () => {
    
    try {
      setError('')
      const mobileNum = sessionStorage.getItem('mobile_no');
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(`${backendUrl}api/v2/resend-otp-exchange/${user_id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": `${auth_token}`,
          'X-CSRF-Token': csrfToken,
        },
        credentials: "include",
        body: JSON.stringify({ userInfo,mobileNum }),
        
      });

      if (!response.ok) {
        throw new Error("Failed to resend OTP");
      }

      setSeconds(60);
      setIsDisabled(true);
    } catch (error) {
      //console.error("Error resending OTP:", error);
      setError("Failed to resend OTP");
    }
  };

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;

    if (isDisabled && seconds > 0) {
      timer = setInterval(() => {
        setSeconds((prev) => prev - 1);
      }, 1000);
    }

    if (seconds <= 0) {
      setIsDisabled(false);
      if (timer) {
        clearInterval(timer);
      }
      handleResendExpireOtp()
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [seconds, isDisabled]);

  const handleOtpSubmit = async () => {
    if (!user_id) {
      setError("User ID is missing.");
      return;
    }

    const otpValue = otp.join(""); // Ensure all 6 digits are joined
    //console.log("------------>>>>", otpValue);

    try {
      setLoading(true); // Start loader
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(
        `${backendUrl}api/v2/verify-otp-daikin/${user_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
          body: JSON.stringify({ userId, otp: otpValue }),
          
        }
      );

      const data = await response.json();

      if (data.data.success) {
        let saveDaikinDetail = await saveDaikinInfo(); // Call after OTP is verified
        let saveDaikinOrderDetails = await saveDaikinOrderInfo();
       
        navigate("/exchange/programechangesubmit", {
          state: { orderNumber: saveDaikinOrderDetails,prog_id },
        });
      } else {
        setError(data.error?.message || "Invalid otp");
        setLoading(false);
        const newOtp = new Array(otp.length).fill(""); // Clear OTP
        setOtp(newOtp);
        nameInputRef.current[0]?.focus();

        // // Focus the first input field
        // const firstInput = document.querySelector(
        //   'input[data-otp-index="0"]'
        // );
        // //console.log("firstInput-------->", firstInput);
        // if (firstInput) {
        //   (firstInput as HTMLInputElement).focus();
        // }
      }
    } catch (err: any) {
      setError(err.message || "An unexpected error occurred");
      setLoading(false);
    }
  };
  useEffect(() => {
    if (otp[0] === "") {
      nameInputRef.current[0]?.focus();
    }
  }, []);

  return (
    <div>
      <Header />
      <main className="main-content-verify">
        <div className="verify-otp-content">
        {error && <p className="error">{error}</p>}
          <p className="heading-otp">Enter Verification OTP</p>
          <div className="verify-rep">
            {otp.map((digit, index) => (
              <input
                key={index}
                type="number"
                className="otp-input-exchange"
                maxLength={1}
                value={digit}
                placeholder="__"
                ref={(el) => (nameInputRef.current[index] = el)}
                onChange={(e) => handleChange(e.target, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                onFocus={(e) => e.target.select()}
              />
            ))}
          </div>
        

          {loading ? (
            <div className="loader"></div>
          ) : (
            <div className="otptext">
              <p className="info">An OTP has been sent to your Mobile No.</p>
              <p className="request">
                {isDisabled
                  ? `Request new OTP in ${seconds}s`
                  : "You can request a new OTP"}
              </p>
            </div>
          )}
          <p className="info" style={{
              cursor: isDisabled ? "not-allowed" : "pointer",
              opacity: isDisabled ? 0 : 1,
            }}>OTP expired. Click on RESEND OTP to get new OTP.</p>

          <div
            className="linkResendotp"
            onClick={handleResendOtp}
            style={{
              cursor: isDisabled ? "not-allowed" : "pointer",
              opacity: isDisabled ? 0.5 : 1,
            }}
          >
            RESEND OTP
          </div>
         
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default VerifyExchangeOtp;
